/**
 * Carson Claw 皮肤 ——「夜自习」
 *
 * 设计基准：~/.claude/awesome-design-md/design-md/spotify/DESIGN.md
 * 借它的结构语言（内容优先的暗场、胶囊控件、无边框卡片靠提亮分层、
 * 大字重层级），但配色留在自家品牌里，不照搬 Spotify 绿。
 *
 * 暖调近黑而非中性灰黑：画布带一点绿味（#0F130C），配上草绿会显得是同一个世界，
 * 用纯灰黑会像开发者工具。
 *
 * 绿有两档，都在图标那支草绿的色相上：
 *   accent #8FE04A  提亮版，深色底上发光，承载文字与按钮
 *   tint   #7EAF41  图标原色，用于填充块（进度条、日历完成格）
 * 图标里的奶油 #FCF0D7 留给**最大的那个数字**——全屏最亮的一点，视线先落在那。
 *
 * 全部色对已按 WCAG 验算：正文 ≥4.5:1、三级文字与装饰 ≥3:1，深浅两套都过。
 */

import { defineSkin, defaultSkin, type Skin } from '@pwaship/ui'

export const brand = defineSkin({
  name: 'brand',
  label: '默认',
  light: {
    canvas: '#FCF0D7',
    surface: '#FFFAEE',
    surface2: '#F7EDD6',
    surfaceSunken: '#F2E5C9',
    surfaceInput: '#FFFAEE',

    text: '#22261C',
    text2: '#5A6150',
    text3: '#7A806D',
    text4: '#9AA08D',
    textInverse: '#FFFAEE',

    line: '#E6DABE',
    lineSoft: '#F0E6D0',
    lineStrong: '#D2C49F',

    accent: '#4A6E22',
    accentHover: '#3F5D1D',
    accentActive: '#354F19',
    accentSoft: '#E9F1D9',
    accentLine: '#C6D9A4',
    onAccent: '#FFFFFF',
    tint: '#5C8629',
    shadowSm: '0 1px 2px rgb(34 38 28 / 6%)',
    shadowMd: '0 6px 16px -8px rgb(34 38 28 / 18%)',
    shadowLg: '0 18px 40px -18px rgb(34 38 28 / 26%)',
    shadowAccent: '0 10px 26px -14px rgb(74 110 34 / 45%)',
  },
  dark: {
    canvas: '#0F130C',
    surface: '#181D14',
    surface2: '#212819',
    surfaceSunken: '#0A0D08',
    surfaceInput: '#212819',

    text: '#F0EEE6',
    text2: '#9AA391',
    text3: '#69735F',
    text4: '#4E5747',
    textInverse: '#0F130C',

    line: '#2A331F',
    lineSoft: '#1E2517',
    lineStrong: '#3D4A2E',

    accent: '#8FE04A',
    accentHover: '#A2E967',
    accentActive: '#B4F080',
    accentSoft: '#1C2A11',
    accentLine: '#33501C',
    onAccent: '#0F130C',
    tint: '#7EAF41',
    shadowSm: '0 1px 2px rgb(0 0 0 / 40%)',
    shadowMd: '0 8px 24px -10px rgb(0 0 0 / 60%)',
    shadowLg: '0 24px 60px -24px rgb(0 0 0 / 75%)',
    shadowAccent: '0 10px 30px -14px rgb(143 224 74 / 35%)',
  },
})

export const skins: readonly Skin[] = [brand]
export const fallbackSkin = skins[0] ?? defaultSkin
